// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bM_1r"};